import { TTheme } from '@/core/theme'

export const getStatusColors = (status: TIssueStatus, theme: TTheme) => {
    switch (status) {
        case 'open':
            return {
                background: theme.colors.semantic.statusOpenBackground,
                color: theme.colors.semantic.statusOpenText,
                border: theme.colors.semantic.statusOpenBorder,
            }
        case 'in_review':
            return {
                background: theme.colors.semantic.statusValidatingBackground,
                color: theme.colors.semantic.statusValidatingText,
                border: theme.colors.semantic.statusValidatingBorder,
            }
        case 'resolved':
            return {
                background: theme.colors.semantic.statusResolvedBackground,
                color: theme.colors.semantic.statusResolvedText,
                border: theme.colors.semantic.statusResolvedBorder,
            }
        case 'approved':
            return {
                background: theme.colors.semantic.statusApprovedBackground,
                color: theme.colors.semantic.statusApprovedText,
                border: theme.colors.semantic.statusApprovedBorder,
            }
        default:
            return {
                background: theme.colors.semantic.statusValidatingBackground,
                color: theme.colors.semantic.statusValidatingText,
                border: theme.colors.semantic.statusValidatingBorder,
            }
    }
}
